import React from 'react';
import TbodyTableConciliaciones from './tbody';
import TheadTableConciliaciones from './thead';

const TableConciliaciones = (props) => {
  const { loadingTables } = props.data;
  return (
    <div className="overflow-x-auto">
      {!loadingTables && (
        <table className="min-w-[1200px] w-full table-auto text-sm">
          <TheadTableConciliaciones />
          <TbodyTableConciliaciones actions={props.actions} />
        </table>
      )}
    </div>
  );
};

export default TableConciliaciones;
